module.exports = __webpack_public_path__ + "static/media/i34.837d666d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i34.svg
// module id = 340
// module chunks = 8